/**
 * Dicas por tela (I2). Uma frase por tela, em linguagem de quem usa — nunca
 * "sincronização", "API" ou "id". A chave é o id do item em `navigation.ts`, o mesmo que
 * o servidor guarda quando a pessoa fecha a dica (formato `^[a-z0-9-]+$`).
 */
export interface ScreenHintText {
  title?: string;
  text: string;
}

export const SCREEN_HINTS: Readonly<Record<string, ScreenHintText>> = {
  dashboard: {
    title: 'Comece por aqui',
    text: 'Este painel responde três perguntas: entrou gente hoje, algum grupo lotou e algum número caiu. Toque num número para ver o detalhe.',
  },
  campanhas: {
    text: 'Evasão é quem entrou e saiu por conta própria. Quem você removeu fica à parte, para não confundir a conta.',
  },
  redirecionadores: {
    text: 'O link do anúncio leva a pessoa ao grupo com vaga. Prévias do WhatsApp e do Facebook não contam como clique.',
  },
  grupos: {
    text: 'Cada grupo cabe até 1.024 pessoas; o rodízio para antes, perto de 980, para nunca mandar ninguém para grupo cheio.',
  },
  monitoradores: {
    text: 'Os números conectados monitoram os grupos. Se um cair, as entradas e saídas param de ser registradas até reconectar.',
  },
  incidentes: {
    text: 'Aqui aparece o que precisa de você agora: número fora do ar, link de grupo quebrado, grupo sem vaga.',
  },
  'analytics-gestao': {
    text: 'Compare campanhas lado a lado. Quando falta um dado, aparece "—" com o motivo — nunca um zero inventado.',
  },
  'analytics-historico': {
    text: 'Veja em que hora do dia as pessoas entram e saem, e quanto tempo cada turma fica no grupo.',
  },
};

export function hintFor(screenId: string | undefined): ScreenHintText | null {
  if (!screenId) return null;
  return SCREEN_HINTS[screenId] ?? null;
}
